import React, { useState, useEffect, useRef } from 'react';
import InputEntidad from '../../common/InputEntidad';
import DatePickerCustom from '../../common/DatePickerCustom';
import { ALERT_TYPE, REQUEST_METHOD, ShowToastMessage, useForm } from '@laramie/ui';
import { APIS } from '../../../config/apis';
import { ServerRequest } from '../../../utils/apiweb';
import {object, func, bool, string} from 'prop-types';
import {CloneObject} from '../../../utils/helpers';
import {useFormErrors} from '../../hooks/useFormErrors';
import {VALIDATION_MESSAGE} from '../../../consts/validationMessage';
import DataTaggerFormRedux from '../DataTaggerFormRedux';
import {Accordion, CheckboxButton, CheckboxButtonGroup, FormError, FormLabel, InputNumber, Modal} from '../../common';
import {TIPS} from "../../../consts/tips";

const ALICUOTA_ERROR = 'error';

const RubroComercioModal = (props) => {

    const entityInit = {
        id: 0,
        idComercio: 0,
        idRubro: 0,
        idUbicacionComercio: 0,
        idRubroLiquidacion: 0,
        idRubroProvincia: 0,
        idRubroBCRA: 0,
        descripcion: '',
        esDeOficio: false,
        esRubroPrincipal: false,
        esConDDJJ: false,
        fechaInicio: null,
        fechaCese: null,
        fechaAltaTransitoria: null,
        fechaBajaTransitoria: null,
        fechaBaja: null,
        idMotivoBajaRubroComercio: 0
    };

    //hooks
    const [state, setState] = useState({
        entity: entityInit
    });

    const [rubroState, setRubroState] = useState({
        categoria: '',
        esGenerico: false,
        esFacturable: false,
        esRegimenGeneral: true,
        alicuota: 0
    });

    const [isFirstRubroState, setIsFirstRubroState] = useState(false);

    //la alicuota que se muestra es la vigente hoy segun la grilla del rubro, no la del rubro sin vigencia.
    //Estados: undefined = consultando, null = el rubro no tiene alicuota vigente (404), ALICUOTA_ERROR = fallo la consulta
    //cada consulta lleva su numero: solo se acepta la respuesta de la ultima, aunque se vuelva al mismo rubro (A, B, A)
    const ultimaConsultaAlicuota = useRef(0);
    const cargarAlicuotaVigente = (idRubro) => {
        const consulta = ++ultimaConsultaAlicuota.current;
        const setAlicuota = (alicuota) => {
            if (consulta !== ultimaConsultaAlicuota.current) return;
            setRubroState(prevState => {
                return {...prevState, alicuota: alicuota};
            });
        };
        setAlicuota(undefined);
        ServerRequest(
            REQUEST_METHOD.GET,
            null,
            true,
            APIS.URLS.RUBRO_ALICUOTA,
            `/current/${idRubro}`,
            null,
            (response) => response.json().then((row) => setAlicuota(row.valor)).catch(() => setAlicuota(ALICUOTA_ERROR)),
            (response) => setAlicuota(response.status === 404 ? null : ALICUOTA_ERROR),
            () => setAlicuota(ALICUOTA_ERROR)
        );
    }

    const mount = () => {
        setState(prevState => {
            return {...prevState, entity: props.data.entity};
        });

        formSet({
            idRubro: props.data.entity.idRubro,
            idUbicacionComercio: props.data.entity.idUbicacionComercio,
            idRubroLiquidacion: props.data.entity.idRubroLiquidacion,
            idRubroProvincia: props.data.entity.idRubroProvincia,
            idRubroBCRA: props.data.entity.idRubroBCRA,
            descripcion: props.data.entity.descripcion,
            esDeOficio: props.data.entity.esDeOficio,
            esRubroPrincipal: props.data.entity.esRubroPrincipal || props.data.isFirstRubro,
            esConDDJJ: props.data.entity.esConDDJJ,
            fechaInicio: props.data.entity.fechaInicio,
            fechaCese: props.data.entity.fechaCese,
            fechaAltaTransitoria: props.data.entity.fechaAltaTransitoria,
            fechaBajaTransitoria: props.data.entity.fechaBajaTransitoria,
            fechaBaja: props.data.entity.fechaBaja,
            idMotivoBajaRubroComercio: props.data.entity.idMotivoBajaRubroComercio,
        });

        setIsFirstRubroState(props.data.isFirstRubro);
    }

    useEffect(mount, [props.data.entity]);

    const [formValues, formHandle, , formSet] = useForm({
        idRubro: 0,
        idUbicacionComercio: 0,
        idRubroLiquidacion: 0,
        idRubroProvincia: 0,
        idRubroBCRA: 0,
        descripcion: '',
        esDeOficio: false,
        esRubroPrincipal: false,
        esConDDJJ: false,
        fechaInicio: null,
        fechaCese: null,
        fechaAltaTransitoria: null,
        fechaBajaTransitoria: null,
        fechaBaja: null,
        idMotivoBajaRubroComercio: 0
    });


    const CAMPOS_ADMINISTRATIVOS = ['idUbicacionComercio', 'idRubroLiquidacion', 'idRubroProvincia', 'idRubroBCRA'];
    const [rubroOpen, setRubroOpen] = useState(true);
    const [administrativosOpen, setAdministrativosOpen] = useState(false);
    const { errorOf, validate } = useFormErrors(getErrors);

    //handles
    const handleClickAceptar = () => {
        const errors = getErrors();
        if (errors.idRubro) setRubroOpen(true);
        if (CAMPOS_ADMINISTRATIVOS.some(campo => errors[campo])) setAdministrativosOpen(true);
        if (!validate()) return;
        let row = CloneObject(state.entity);
        row.idRubro = parseInt(formValues.idRubro);
        row.idUbicacionComercio = parseInt(formValues.idUbicacionComercio);
        row.idRubroLiquidacion = parseInt(formValues.idRubroLiquidacion);
        row.idRubroProvincia = parseInt(formValues.idRubroProvincia);
        row.idRubroBCRA = parseInt(formValues.idRubroBCRA);
        row.descripcion = formValues.descripcion;
        row.esDeOficio = formValues.esDeOficio;
        row.esRubroPrincipal = formValues.esRubroPrincipal;
        row.esConDDJJ = formValues.esConDDJJ;
        row.fechaInicio = formValues.fechaInicio;
        row.fechaCese = formValues.fechaCese;
        row.fechaAltaTransitoria = formValues.fechaAltaTransitoria;
        row.fechaBajaTransitoria = formValues.fechaBajaTransitoria;
        row.fechaBaja = formValues.fechaBaja;
        row.idMotivoBajaRubroComercio = parseInt(formValues.idMotivoBajaRubroComercio);

        props.onConfirm(row);
    };

    //funciones
    function getErrors() {

        const errors = {};

        if (formValues.idRubro <= 0) errors.idRubro = VALIDATION_MESSAGE.REQUIRED_OPTION;
        if (formValues.idUbicacionComercio <= 0) errors.idUbicacionComercio = VALIDATION_MESSAGE.REQUIRED_OPTION;
        if (formValues.idRubroLiquidacion <= 0) errors.idRubroLiquidacion = VALIDATION_MESSAGE.REQUIRED_OPTION;
        if (formValues.idRubroProvincia <= 0) errors.idRubroProvincia = VALIDATION_MESSAGE.REQUIRED_OPTION;
        if (formValues.idRubroBCRA <= 0) errors.idRubroBCRA = VALIDATION_MESSAGE.REQUIRED_OPTION;

        return errors;
    }

    return (
        <>

            <Modal
                size="xl"
                title={`Rubro comercio: ${(state.entity.id > 0) ? state.entity.descripcion : "Nuevo"}`}
                tipName={TIPS.NAME.MODALS.RUBRO_COMERCIO_MODAL}
                onEscape={() => props.onDismiss()}
                body={(
                            <div className="row">

                                <div className="mb-3 col-12">
                                    <Accordion title="Datos del rubro" open={rubroOpen} onToggle={setRubroOpen}>
                                            <div className='row form-basic'>
                                                <div className="col-12 col-md-8">
                                                    <FormLabel htmlFor="idRubro" required>Tipo de
                                                        rubro</FormLabel>
                                                    <InputEntidad
                                                        name="idRubro"
                                                        placeholder=""
                                                        tipName={TIPS.NAME.MODALS.TIPO_RUBRO_COMERCIO_MODAL}
                                                        className={`form-control ${errorOf('idRubro') ? 'is-invalid' : ''}`}
                                                        value={formValues.idRubro}
                                                        onChange={formHandle}
                                                        onUpdate={(event) => {
                                                            if (event.target.row) {
                                                                setRubroState(prevState => {
                                                                    return {
                                                                        ...prevState,
                                                                        categoria: event.target.row.categoria,
                                                                        esGenerico: event.target.row.generico,
                                                                        esFacturable: event.target.row.facturable,
                                                                        esRegimenGeneral: event.target.row.regimenGeneral,
                                                                    }
                                                                })
                                                                cargarAlicuotaVigente(event.target.row.id);
                                                            }
                                                        }}
                                                        onFormat={row => (row) ? `${row.codigo} - ${row.nombre}` : ''}
                                                        disabled={props.disabled}
                                                        title="Tipo rubro comercio"
                                                        entidad="Rubro"
                                                    />
                                                    <FormError message={errorOf('idRubro')} />
                                                </div>
                                                <div className="col-6 col-md-2">
                                                    <label htmlFor="categoria" className="form-label">Categoría</label>
                                                    <input
                                                        name="categoria"
                                                        type="text"
                                                        placeholder=""
                                                        className="form-control"
                                                        value={rubroState.categoria}
                                                        disabled={true}
                                                    />
                                                    <FormError />
                                                </div>
                                                <div className="col-6 col-md-2">
                                                    <label htmlFor="alicuota" className="form-label">Alícuota vigente</label>
                                                    {rubroState.alicuota === null || rubroState.alicuota === ALICUOTA_ERROR ?
                                                    <input
                                                        name="alicuota"
                                                        type="text"
                                                        className={`form-control ${rubroState.alicuota === ALICUOTA_ERROR ? 'is-invalid' : ''}`}
                                                        value={!formValues.idRubro ? "" : (rubroState.alicuota === ALICUOTA_ERROR ? "No se pudo consultar" : "Sin alícuota vigente")}
                                                        disabled={true}
                                                    />
                                                    :
                                                    <InputNumber
                                                        name="alicuota"
                                                        type="text"
                                                        className="form-control"
                                                        value={rubroState.alicuota}
                                                        precision={2}
                                                        disabled={true}
                                                    />
                                                    }
                                                    {rubroState.alicuota === ALICUOTA_ERROR && formValues.idRubro ?
                                                    <button type="button" className="btn btn-link btn-sm p-0" onClick={() => cargarAlicuotaVigente(formValues.idRubro)}>Reintentar</button>
                                                    : null}
                                                    <FormError />
                                                </div>
                                                <div className="col-12">
                                                    <CheckboxButtonGroup label="Opciones">
                                                        <CheckboxButton
                                                            name="esGenerico"
                                                            label="Genérico"
                                                            checked={rubroState.esGenerico}
                                                            onChange={() => {}}
                                                            disabled={true}
                                                        />
                                                        <CheckboxButton
                                                            name="esFacturable"
                                                            label="Facturable"
                                                            checked={rubroState.esFacturable}
                                                            onChange={() => {}}
                                                            disabled={true}
                                                        />
                                                        <CheckboxButton
                                                            name="esRegimenGeneral"
                                                            label="Régimen general"
                                                            checked={rubroState.esRegimenGeneral}
                                                            onChange={() => {}}
                                                            disabled={true}
                                                        />
                                                    </CheckboxButtonGroup>
                                                </div>
                                            </div>
                                    </Accordion>
                                </div>

                                <div className="mb-3 col-12">
                                    <Accordion title="Datos administrativos" open={administrativosOpen} onToggle={setAdministrativosOpen}>
                                            <div className='row form-basic'>
                                                <div className="col-12 col-md-6">
                                                    <FormLabel htmlFor="idUbicacionComercio" required>Ubicación</FormLabel>
                                                    <InputEntidad
                                                        name="idUbicacionComercio"
                                                        placeholder=""
                                                        tipName={TIPS.NAME.MODALS.TIPO_UBICACION_COMERCIO_MODAL}
                                                        className={`form-control ${errorOf('idUbicacionComercio') ? 'is-invalid' : ''}`}
                                                        value={formValues.idUbicacionComercio}
                                                        onChange={formHandle}
                                                        disabled={props.disabled}
                                                        title="Ubicación Comercio"
                                                        entidad="UbicacionComercio"
                                                    />
                                                    <FormError message={errorOf('idUbicacionComercio')} />
                                                </div>
                                                <div className="col-12 col-md-6">
                                                    <FormLabel htmlFor="idRubroLiquidacion" required>Rubros
                                                        liquidación</FormLabel>
                                                    <InputEntidad
                                                        name="idRubroLiquidacion"
                                                        placeholder=""
                                                        tipName={TIPS.NAME.MODALS.TIPO_RUBRO_LIQUIDACION_MODAL}
                                                        className={`form-control ${errorOf('idRubroLiquidacion') ? 'is-invalid' : ''}`}
                                                        value={formValues.idRubroLiquidacion}
                                                        onChange={formHandle}
                                                        disabled={props.disabled}
                                                        title="Rubro Liquidación"
                                                        entidad="RubroLiquidacion"
                                                    />
                                                    <FormError message={errorOf('idRubroLiquidacion')} />
                                                </div>
                                                <div className="col-12 col-md-3">
                                                    <FormLabel htmlFor="idRubroProvincia" required>Tipo
                                                        liquidación</FormLabel>
                                                    <InputEntidad
                                                        name="idRubroProvincia"
                                                        placeholder=""
                                                        tipName={TIPS.NAME.MODALS.TIPO_RUBRO_PROVINCIA_MODAL}
                                                        className={`form-control ${errorOf('idRubroProvincia') ? 'is-invalid' : ''}`}
                                                        value={formValues.idRubroProvincia}
                                                        onChange={formHandle}
                                                        disabled={props.disabled}
                                                        title="Tipo liquidación"
                                                        entidad="RubroProvincia"
                                                    />
                                                    <FormError message={errorOf('idRubroProvincia')} />
                                                </div>
                                                <div className="col-12 col-md-3">
                                                    <FormLabel htmlFor="idRubroBCRA" required>Rubros
                                                        BCRA</FormLabel>
                                                    <InputEntidad
                                                        name="idRubroBCRA"
                                                        placeholder=""
                                                        tipName={TIPS.NAME.MODALS.TIPO_RUBRO_BCRA_MODAL}
                                                        className={`form-control ${errorOf('idRubroBCRA') ? 'is-invalid' : ''}`}
                                                        value={formValues.idRubroBCRA}
                                                        onChange={formHandle}
                                                        disabled={props.disabled}
                                                        title="Rubro BCRA"
                                                        entidad="RubroBCRA"
                                                    />
                                                    <FormError message={errorOf('idRubroBCRA')} />
                                                </div>
                                                <div className="col-12 col-md-6">
                                                    <label htmlFor="descripcion"
                                                           className="form-label">Descripción</label>
                                                    <input
                                                        name="descripcion"
                                                        type="text"
                                                        placeholder=""
                                                        className="form-control"
                                                        value={formValues.descripcion}
                                                        onChange={formHandle}
                                                        disabled={props.disabled}
                                                    />
                                                    <FormError />
                                                </div>
                                                <div className="col-12">
                                                    <CheckboxButtonGroup label="Opciones">
                                                        <CheckboxButton
                                                            name="esDeOficio"
                                                            label="De oficio"
                                                            checked={formValues.esDeOficio}
                                                            onChange={formHandle}
                                                            disabled={props.disabled}
                                                        />
                                                        <CheckboxButton
                                                            name="esRubroPrincipal"
                                                            label="Rubro principal"
                                                            checked={formValues.esRubroPrincipal}
                                                            onChange={formHandle}
                                                            disabled={isFirstRubroState || props.disabled}
                                                        />
                                                        <CheckboxButton
                                                            name="esConDDJJ"
                                                            label="Con DDJJ"
                                                            checked={formValues.esConDDJJ}
                                                            onChange={formHandle}
                                                            disabled={props.disabled}
                                                        />
                                                    </CheckboxButtonGroup>
                                                </div>
                                                <div className="col-6 col-md-3 col-lg-3">
                                                    <label htmlFor="fechaInicio" className="form-label">Fecha
                                                        inicio</label>
                                                    <DatePickerCustom
                                                        name="fechaInicio"
                                                        placeholder=""
                                                        className="form-control"
                                                        value={formValues.fechaInicio}
                                                        onChange={formHandle}
                                                        disabled={props.disabled}
                                                    />
                                                </div>
                                                {
                                                    /* <div className="col-6 col-md-3 col-lg-3">
                                                <label htmlFor="fechaCese" className="form-label">Fecha cese</label>
                                                <DatePickerCustom
                                                    name="fechaCese"
                                                    placeholder=""
                                                    className="form-control"
                                                    value={ formValues.fechaCese }
                                                    onChange={ formHandle }
                                                    disabled={ props.disabled }
                                                />
                                            </div>
                                            <div className="col-6 col-md-3 col-lg-3">
                                                <label htmlFor="fechaAltaTransitoria" className="form-label">Alta transitoria</label>
                                                <DatePickerCustom
                                                    name="fechaAltaTransitoria"
                                                    placeholder=""
                                                    className="form-control"
                                                    value={ formValues.fechaAltaTransitoria }
                                                    onChange={ formHandle }
                                                    disabled={ props.disabled }
                                                />
                                            </div>
                                            <div className="col-6 col-md-3 col-lg-3">
                                                <label htmlFor="fechaBajaTransitoria" className="form-label">Baja transitoria</label>
                                                <DatePickerCustom
                                                    name="fechaBajaTransitoria"
                                                    placeholder=""
                                                    className="form-control"
                                                    value={ formValues.fechaBajaTransitoria }
                                                    onChange={ formHandle }
                                                    disabled={ props.disabled }
                                                />
                                            </div> */
                                                }

                                            </div>
                                    </Accordion>
                                </div>

                                <div className="mb-3 col-12">
                                    <Accordion title="Información de baja">
                                            <div className='row form-basic'>
                                                <div className="col-12 col-md-3">
                                                    <label htmlFor="fechaBaja" className="form-label">Fecha baja</label>
                                                    <DatePickerCustom
                                                        name="fechaBaja"
                                                        placeholder=""
                                                        className="form-control"
                                                        value={formValues.fechaBaja}
                                                        onChange={formHandle}
                                                        disabled={props.disabled}
                                                    />
                                                </div>
                                                <div className="col-12 col-md-3">
                                                    <label htmlFor="idMotivoBajaRubroComercio" className="form-label">Motivo
                                                        de baja</label>
                                                    <InputEntidad
                                                        name="idMotivoBajaRubroComercio"
                                                        placeholder=""
                                                        tipName={TIPS.NAME.MODALS.TIPO_MOTIVO_BAJA_RUBRO_COMERCIO_MODAL}
                                                        className="form-control"
                                                        value={formValues.idMotivoBajaRubroComercio}
                                                        onChange={formHandle}
                                                        disabled={props.disabled}
                                                        title="Motivo baja rubro comercio"
                                                        entidad="MotivoBajaRubroComercio"
                                                    />
                                                </div>
                                            </div>
                                    </Accordion>
                                </div>

                                <div className="mb-3 col-12">
                                    <Accordion title="Información adicional">
                                            <DataTaggerFormRedux
                                                title="Información adicional de rubros comercio"
                                                tipName={TIPS.NAME.MODALS.INFORMACION_ADICIONAL_RUBRO_COMERCIO_MODAL}
                                                processKey={props.processKey}
                                                entidad="RubroComercio"
                                                idEntidad={state.entity.id}
                                                disabled={props.disabled}
                                            />
                                    </Accordion>
                                </div>

                            </div>
                )}
                footer={!props.disabled ? (<>
                                <button className="btn btn-outline-primary" data-dismiss="modal"
                                        onClick={(event) => props.onDismiss()}>Cancelar
                                </button>
                                <button className="btn btn-primary" data-dismiss="modal"
                                        onClick={(event) => handleClickAceptar()}>Aceptar
                                </button>
                </>) : (<>
                                <button className="btn back-button" data-dismiss="modal"
                                        onClick={(event) => props.onDismiss()}>Volver
                                </button>
                                {props.onMovePrevious &&
                                    <button className="btn btn-i" data-dismiss="modal"
                                            onClick={(event) => props.onMovePrevious()}>
                                        <span className="material-symbols-outlined tooltip-container"
                                              title='Anterior'>chevron_left</span>
                                    </button>
                                }
                                {props.onMoveNext &&
                                    <button className="btn btn-i" data-dismiss="modal"
                                            onClick={(event) => props.onMoveNext()}>
                                        <span className="material-symbols-outlined tooltip-container"
                                              title='Siguiente'>chevron_right</span>
                                    </button>
                                }
                </>)}
                footerClassName={props.disabled ? 'f-align' : ''}
            />

        </>
    );
}

RubroComercioModal.propTypes = {
    processKey: string.isRequired,
    disabled: bool,
    data: object.isRequired,
    onConfirm: func.isRequired,
    onDismiss: func.isRequired,
    onMovePrevious: func,
    onMoveNext: func
};

RubroComercioModal.defaultProps = {
    disabled: false,
    onMovePrevious: null,
    onMoveNext: null
};

export default RubroComercioModal;